import {
  Component,
  ChangeDetectionStrategy,
  HostListener,
  ElementRef,
  Input,
  Output,
  EventEmitter,
  AfterViewChecked,
  ViewChild,
} from '@angular/core';

import { MULTIPLE_REQUESTS } from '../../constants';

@Component({
  selector: 'cs-main-bar',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div
      class="cs-tabs"
      (click)="closeDropdown()">
      
      <!-- Real tabs -->
      <div class="cs-tabs__tabs">
        <!-- Button that toggles dropdown menu -->
        <a 
          class="cs-btn cs-tabs__menu-toggle"
          (click)="toggleDropdown($event)">
          <span class="ion-navicon-round"></span>
        </a>
        
        <!-- Arrow to scroll tabs on the left -->
        <a 
          class="cs-btn cs-tabs__arrow"
          *ngIf="showArrows">
          <span class="ion-chevron-left"></span>
        </a>
        
        <div class="cs-tabs__list-container" 
             #tabsBox>
          <ul class="cs-tabs__list"
               #tabsList>
            <li
              class="cs-tabs__item"
              [ngClass]="{
                'is-completed cursor-default': isDisabled(section, i -1), 
                'is-current': isSameOfCurrent(section)
              }"
              (click)="sectionClick($event, section, i -1)"
              *ngFor="let section of inputs.sections; let i = index">
              <a>
                <span 
                    [ngClass]="{
                      'ion-checkmark-circled' : isSectionLoaded(section) && section.completed, 
                      'ion-record' : !section.completed
                    }"
                  [style.color]="isSectionLoaded(section) ? section.colore : '#ababab'">
                </span> 
                {{ section.nome }}
              </a>
            </li>
          </ul>
        </div>
        
        <!-- Arrow to scroll tabs on the right -->
        <a 
          class="cs-btn cs-tabs__arrow"
          *ngIf="showArrows">
          <span class="ion-chevron-right"></span>
        </a>
      </div>
      <!-- END // Real tabs -->
      
      <!-- Dropdown with list of the same links in the tabs -->
      <div 
        class="cs-tabs__dropdown"
        *ngIf="showDropdown">
        <ul class="cs-tabs__dropdown-list">
          <li
            class="cs-tabs__dropdown-item"
            [ngClass]="{
              'is-completed cursor-default': isDisabled(section, i -1), 
              'is-current': isSameOfCurrent(section)
            }"
            (click)="sectionClick($event, section, i -1)"
            *ngFor="let section of inputs.sections; let i = index">
            <a>
              <span
                  [ngClass]="{
                    'ion-checkmark-circled' : isSectionLoaded(section) && section.completed, 
                    'ion-record' : isSectionLoaded(section) && !section.completed, 
                    'ion-load-a': !isSectionLoaded(section)
                  }"
                [style.color]="section.colore">
              </span> 
              {{ section.nome }}
            </a>
          </li>
        </ul>
      </div>
      <!-- END // Dropdown with list of the same links in the tabs -->
    </div>
  `
})

export class CsMainBarComponent implements AfterViewChecked {
  showDropdown: boolean;
  showArrows: boolean = false;
  lastOffset: number;
  @ViewChild('tabsBox') tabsBox: ElementRef;
  @ViewChild('tabsList') tabsList: ElementRef;

  @Input() inputs: any = {};
  @Output() requestNewSection = new EventEmitter<Object>();

  @HostListener('document:click', ['$event', '$event.target'])
  onClick(event: MouseEvent, targetElement: HTMLElement): void {
    if (!targetElement) {
      return;
    }

    if (!this._eref.nativeElement.contains(event.target)) {
      this.showDropdown = false;
    }
  }

  constructor(
    private _eref: ElementRef
  ) { }

	ngAfterViewChecked(){
    this.offsetControl();
	}

	offsetControl(){
		let list = this.tabsList.nativeElement;
		let box = this.tabsBox.nativeElement;
		let boxOffset = box.offsetWidth;
    let listItems = Array.from(list.children);
    let controlEl: any;
    let controlElOffset: any;

    listItems.forEach((item: any, index) => {
      const classes = Array.from(item.classList);
      if(classes.indexOf('is-current') !== -1){
        controlEl = ((index + 1) === listItems.length) ? item : listItems[index+1];
        controlElOffset = controlEl.offsetLeft + controlEl.offsetWidth;
        return;
      }
    });

		if(
      (this.lastOffset !== controlElOffset) && 
      (controlElOffset >= boxOffset) 
    ){
      this.lastOffset = controlElOffset;
			let move_to = Math.ceil(boxOffset - controlElOffset);
			list.style.left = `${move_to}px`;
		}
	}

  isDisabled(section, indexPrev) {
    if (this.inputs.isCompleted) {
      return false;
    }

    if (this.inputs.sections[indexPrev]) {
      return !this.isSameOfCurrent(section) &&
        !this.isSameOfCurrent(this.inputs.sections[indexPrev]);
    } else {
      return !this.isSameOfCurrent(section);
    }
  }

  isSameOfCurrent(section) {
    return section && this.inputs.current &&
      section.id === this.inputs.current.id;
  }

  isSectionLoaded(section) {
    if(!MULTIPLE_REQUESTS) return true;

    const loadedRicette = this.inputs.loadedRicette || {};
    return loadedRicette[section.id];
  }

  sectionClick(event, section, indexPrev) {
    if (!this.inputs.canChangeSection) {
      return;
    }
    if (this.isDisabled(section, indexPrev) || this.isSameOfCurrent(section)) {
      event.stopPropagation();
      return;
    }

    this.requestNewSection.emit(section);
  }

  toggleDropdown(event) {
    this.showDropdown = !this.showDropdown;
    event.stopPropagation();
  }

  closeDropdown() {
    this.showDropdown = false;
  }
}



// WEBPACK FOOTER //
// ./src/app/components/cs-main-bar/cs-main-bar.component.ts